import Auth from '@js/plugins/auth';

export default {
    computed: {
        canAccessAllOutlets() {
            return Auth.canAccessAllOutlets();
        },

        firstAvailableOutlet() {
            if (this.canAccessAllOutlets) {
                return 0;
            }

            return _.first(Auth.outlets());
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/auth.js